import { audios } from "../helpers/audios";

export const library = [
    {
      title: "Hyperspace",
      image:
        "https://monkeybuzz.com.br/wp-content/uploads/2019/12/beck-hyperspace-album-artwork.jpg",
      artist: "Beck",
      year: 2019,
      genre: "Alternative",
      description: "Hyperspace is the fourteenth studio album by American musician Beck.",
      tracks: [
        { name: "Hyperlife", duration: "1:42", url: "./music/my war.mp3" },
        { name: "Uneventful Days", duration: "3:17", url: "./music/my war.mp3" }
      ]
    },
    {
      title: "Non Fungible",
      image:
        "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fbarbaraiweins.com%2Fwp-content%2Fuploads%2F2022%2F03%2FCrypto-Tokens.jpg&f=1&nofb=1&ipt=9462c3c9d7190982985a05af08ee2276afd06bfb2bb0e4b20d0598b76140f4f1",
      contract: "0x1C45d483515A92fCDD0aa5eaF03dbdf1B7d6898a",
    },
    {
      title: "Treezus 2",
      image:
        "https://d1fdloi71mui9q.cloudfront.net/QCgjMRouQHeLFuDfhG22_IMG_1278.JPG",
    },
    {
      title: "Get Rich Or Die Tryin'",
      image: "https://m.media-amazon.com/images/I/61AYpcmBtpL._SY450_.jpg",
    },
    {
      title: "Starboy",
      image:
        "https://i.pinimg.com/originals/49/a0/7a/49a07a20041787942f62dbe900573ecb.jpg",
    },
    {
      title: "Evolve",
      image:
        "https://external-preview.redd.it/v_5XzwOWnjqrz5gBDfENNoMV9Kl8OAAy3015hcTsVYs.jpg?auto=webp&s=5485881fc8e107c14bca6d16c61fa085a78b70b6",
  
    },
    {
      title: "Back From The Dead",
      image:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/a5/16/62/a5166262-81f6-724e-8393-cdca234c81a1/artwork.jpg/316x316bb.webp",
    },
    {
      title: "Ball Breaker",
      image:
        "https://scale.coolshop-cdn.com/product-media.coolshop-cdn.com/AN5W2E/b0cb0df8c30d479da36443c10bc85b96.jpg/f/ac-dc-ballbreaker-framed-album-cover-30x30cm.jpg",
    },
    {
      title: "Flavors",
      image:
        "https://i.scdn.co/image/ab67616d0000b27394f9ac6c17803f2c979624fb",
    },
    {
      title: "Shakira",
      image:
        "https://upload.wikimedia.org/wikipedia/en/3/35/Shakira_-_Shakira_%282014%29.png",
    },
    {
      title: "Adele 21",
      image:
        "https://upload.wikimedia.org/wikipedia/fi/5/51/Adele21albumikansi.jpg",
    },
    {
      title: "Strange Clouds",
      image:
        "https://upload.wikimedia.org/wikipedia/en/6/69/B.o.B_-_Strange_Clouds_-_LP_Cover.jpg",
    },
    {
      title: "Shadow",
      image:
        "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.pixabay.com%2Fphoto%2F2020%2F07%2F06%2F19%2F08%2Fperson-5378092_1280.png&f=1&nofb=1&ipt=58a1f1683b3ff0ff90811eb35d6da7b99e577040e099ab0509a728542a736354",
      contract: "0x8A68d4e28515815CD6026416f4B2a4B647796F3E",
    },
    {
      title: "Arctic Monkeys",
      image:
        "https://i.pinimg.com/originals/c1/83/44/c1834474ec73e7faa475d68fdd791a48.jpg",
    },
    {
      title: "My Everything",
      image:
        "https://upload.wikimedia.org/wikipedia/en/d/d5/Ariana_Grande_My_Everything_2014_album_artwork.png",
    },
    {
      title: "Have A Nice Day",
      image:
        "https://upload.wikimedia.org/wikipedia/de/thumb/e/e5/Bon_Jovi_Have_a_Nice_Day.svg/1200px-Bon_Jovi_Have_a_Nice_Day.svg.png",
    },
    {
      title: "Happier",
      image:
        "https://upload.wikimedia.org/wikipedia/en/e/e5/Marshmello_and_Bastille_Happier.png",
    },
    {
      title: "Stoney",
      image:
        "https://upload.wikimedia.org/wikipedia/fi/d/d9/Post_Malone_Stoney.jpg",
    },
    {
      title: "The Eminem Show",
      image:
        "https://upload.wikimedia.org/wikipedia/en/3/35/The_Eminem_Show.jpg",
    },
    
  ]; //library of albums

// Example usage in albumList.js or useAlbum.js
// console.log(audios[0].name); "Song One"
// console.log(audios[0].url);  "https://www.example.com/song1.mp3"